import { Navigate, Outlet, Link, useLocation } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiBaseball } from '@mdi/js'
import { LogOut } from 'lucide-react'
import { useMe, useLogout } from '@/hooks/useAuth'
import { PageSpinner } from '@/components/ui/Spinner'
import { useAuthStore } from '@/store/auth'

export function AdminShell() {
  const { isLoading, isError } = useMe()
  const user = useAuthStore((s) => s.user)
  const logout = useLogout()
  const location = useLocation()

  if (isLoading) return <PageSpinner />
  if (isError)   return <Navigate to="/login" replace />

  const isActive = (path: string) => location.pathname === path

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top bar */}
      <header className="bg-brand-950 px-6 py-3 flex items-center gap-3 shrink-0">
        <Icon path={mdiBaseball} size={0.9} className="text-brand-400" />
        <span className="text-white font-bold text-lg tracking-tight flex-1">DiamondOps</span>
        <span className="text-white/50 text-xs mr-3">Super Admin</span>
        <span className="text-white/70 text-sm mr-4">{user?.email}</span>
        <button
          onClick={() => logout.mutate()}
          className="flex items-center gap-1.5 text-white/60 hover:text-white text-sm transition-colors"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </header>

      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 px-6">
        <div className="flex gap-6">
          <Link
            to="/admin/tenants"
            className={`px-1 py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive('/admin/tenants')
                ? 'text-brand-600 border-brand-600'
                : 'text-gray-600 border-transparent hover:text-gray-900'
            }`}
          >
            Tenants
          </Link>
          <Link
            to="/admin/settings"
            className={`px-1 py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive('/admin/settings')
                ? 'text-brand-600 border-brand-600'
                : 'text-gray-600 border-transparent hover:text-gray-900'
            }`}
          >
            Settings
          </Link>
          <Link
            to="/admin/oauth-clients"
            className={`px-1 py-3 text-sm font-medium border-b-2 transition-colors ${
              isActive('/admin/oauth-clients')
                ? 'text-brand-600 border-brand-600'
                : 'text-gray-600 border-transparent hover:text-gray-900'
            }`}
          >
            MCP Clients
          </Link>
        </div>
      </nav>

      {/* Page content */}
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
